<template>
  <FormulateInput
    ref="uomField"
    :key="inputKey"
    class="p-0"
    v-bind="field"
    validation-behavior="live"
    :name="`${field.name}-${id}-${index}`"
    :optionsGetter="computedOptionsGetter"
    :label="null"
    :help="true"
    :fullObject="fullObject"
    :value="computedValue"
    @input="handleInput"
    @update:fullObject="$emit('update:fullObject', $event)"
  />
</template>

<script>
import * as Uom from '@/services/rest-api/lib/product/uom'

export default {
  props: {
    value: {},
    field: {},
    fullObject: {},
    id: {},
    index: {},
    productId: {},
  },
  emits: ['input', 'update:fullObject'],
  computed: {
    computedValue() {
      // if it's empty, always return null
      if (this.value === '' || this.value === false) return null

      return this.value
    },
    inputKey() {
      return `${this.field?.name}-${this.id}-${this.index}-${this.productId ?? 'empty'}-${this.computedValue ?? 'empty'}`
    },
    computedOptionsGetter() {
      const productId = this.productId
      let optionsGetter = null

      // set optionsGetter if product id is selected
      if (productId !== null) {
        optionsGetter = Uom.get(productId)
      }

      return optionsGetter
    },
  },
  watch: {
    productId(newValue, oldValue) {
      if (newValue == oldValue) return

      this.resetProperties()
      this.$emit('input', null)
      this.$emit('update:fullObject', {})
    },
  },
  methods: {
    resetProperties() {
      this.$refs.uomField?.$children?.[0]?.ResetProperties?.()
    },
    handleInput(newValue) {
      if (newValue === '' || newValue === false || newValue === undefined || newValue === null) {
        this.$emit('input', null)
        return
      }

      if (Array.isArray(newValue) && newValue.length === 0) {
        this.$emit('input', null)
        return
      }

      this.$emit('input', newValue)
    },
  },
}
</script>
